import { teacherServiceURL } from '../endpoint';

export const foldersURL = () => new URL('/v3/folders', teacherServiceURL);

export function renameFoldersUrl(folderId: number) {
  const url = foldersURL();
  url.pathname += `/rename/${folderId}`;
  return url;
}
